
/*! CTA Press State Manager â€” v4 (2025-09-12) â€“ minimal observers */
(() => {
  const ADD_BTN = '.custom-quick-add-button';
  const VIEW_BTN = '.custom-quick-view-button';
  const SELECTOR = `${ADD_BTN},${VIEW_BTN}`;

  function closestBtn(target) {
    let el = target && (target.nodeType === 1 ? target : target.parentElement);
    return el ? el.closest(SELECTOR) : null;
  }
  const isDisabled = (b) =>
    !b || b.hasAttribute('disabled') ||
    b.getAttribute('aria-disabled') === 'true' ||
    b.classList.contains('is-disabled');

  function onDown(e) {
    const b = closestBtn(e.target);
    if (isDisabled(b)) return;
    b.classList.add('is-pressed');
    if (b.matches(ADD_BTN)) b.classList.add('is-loading');
  }
  function onUp(e) {
    const b = closestBtn(e.target);
    if (!b) return;
    b.classList.remove('is-pressed');
    if (b.matches(VIEW_BTN)) b.classList.remove('is-loading');
  }
  function clearLoading() {
    document.querySelectorAll(`${ADD_BTN}.is-loading`).forEach(b => b.classList.remove('is-loading'));
  }

  // Targeted observers (no subtree scanning)
  function watchToast() {
    const toast = document.getElementById('toast');
    if (!toast) return;
    const mo = new MutationObserver(() => {
      if (toast.classList.contains('visible')) clearLoading();
    });
    mo.observe(toast, { attributes: true, attributeFilter: ['class'] });
  }
  function watchCartDrawer() {
    const drawer = document.querySelector('cart-drawer, #CartDrawer');
    if (!drawer) return;
    const mo = new MutationObserver(() => clearLoading());
    mo.observe(drawer, { attributes: true, attributeFilter: ['open','class','style','aria-hidden'] });
  }

  document.addEventListener('sadwich:cart-added', clearLoading);
  document.addEventListener('sadwich:cart-error', clearLoading);
  document.addEventListener('cart-drawer:open', clearLoading);
  document.addEventListener('cart-notification:show', clearLoading);

  document.addEventListener('pointerdown', onDown, true);
  document.addEventListener('pointerup', onUp, true);
  document.addEventListener('pointercancel', onUp, true);
  document.addEventListener('pointerleave', onUp, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { watchToast(); watchCartDrawer(); });
  } else {
    watchToast(); watchCartDrawer();
  }
})();